export default "__VITE_ASSET__DODdqBTq__"